const SingaporeSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112326)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 20.0001C0 8.95438 8.95437 0 20 0C31.0456 0 40 8.95438 40 20.0001"
        fill="#D80027"
      />
      <path
        d="M12.1737 10.4355C12.1737 7.5216 14.2216 5.08738 16.9563 4.49012C16.536 4.3984 16.0999 4.34863 15.6519 4.34863C12.2901 4.34863 9.56494 7.07379 9.56494 10.4356C9.56494 13.7974 12.2901 16.5225 15.6519 16.5225C16.0998 16.5225 16.5359 16.4728 16.9563 16.381C14.2216 15.7837 12.1737 13.3495 12.1737 10.4355Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 4.7832L20.4317 6.11172H21.8287L20.6984 6.93289L21.1301 8.26141L20 7.44039L18.8698 8.26141L19.3015 6.93289L18.1714 6.11172H19.5683L20 4.7832Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.6115 7.3916L17.0431 8.7202H18.4401L17.3099 9.54129L17.7416 10.8698L16.6115 10.0488L15.4812 10.8698L15.913 9.54129L14.7827 8.7202H16.1797L16.6115 7.3916Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.3887 7.3916L23.8205 8.7202H25.2173L24.0871 9.54129L24.5189 10.8698L23.3887 10.0488L22.2585 10.8698L22.6902 9.54129L21.5601 8.7202H22.9569L23.3887 7.3916Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.0845 11.3047L22.5162 12.6333H23.913L22.7829 13.4544L23.2146 14.7829L22.0845 13.9619L20.9543 14.7829L21.386 13.4544L20.2559 12.6333H21.6527L22.0845 11.3047Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.9151 11.3047L18.3467 12.6333H19.7438L18.6135 13.4544L19.0453 14.7829L17.9151 13.9619L16.7849 14.7829L17.2166 13.4544L16.0864 12.6333H17.4834L17.9151 11.3047Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112326">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SingaporeSvg;
